import { render, staticRenderFns } from "./property.vue?vue&type=template&id=6c767ef4&scoped=true"
import script from "./property.vue?vue&type=script&lang=js"
export * from "./property.vue?vue&type=script&lang=js"
import style0 from "./property.vue?vue&type=style&index=0&id=6c767ef4&prod&lang=scss&scoped=true"
import style1 from "./property.vue?vue&type=style&index=1&id=6c767ef4&prod&lang=scss"
import style2 from "./property.vue?vue&type=style&index=2&id=6c767ef4&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c767ef4",
  null
  
)

export default component.exports